import { action } from 'typesafe-actions';
import { LayoutActionTypes } from './types';

export const sectionSelected = (sectionTitle: string) => {
  return (dispatch: any) => {
    dispatch(action(LayoutActionTypes.SECTION_VIEW_SELECTED, sectionTitle));
  };
};



// WEBPACK FOOTER //
// ./src/store/layout/actions.ts